import { render, staticRenderFns } from "./topicAnswer.vue?vue&type=template&id=7b6f03b7"
import script from "./topicAnswer.vue?vue&type=script&lang=js"
export * from "./topicAnswer.vue?vue&type=script&lang=js"
import style0 from "./topicAnswer.vue?vue&type=style&index=0&id=7b6f03b7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports